export default __webpack_public_path__ + "static/media/model-designer.e89d268b.svg";